import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import StudentEngagementGauge from './StudentEngagementGauge';
import { StudentEngagementListService } from '../../services/CustomerSuccessKpiListService';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';

class StudentEngagementGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    StudentEngagementListService.load();
  }

  render() {
    return (
      <StudentEngagementGauge
        loading={
          StudentEngagementListService.fetchCurrent.fetching || StudentEngagementListService.fetchPrevious.fetching
        }
        currentValue={toJS(StudentEngagementListService.global.current)}
        previousValue={toJS(StudentEngagementListService.global.previous)}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('STUDENT_ENGAGEMENT')}
        formatter={StudentEngagementListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentEngagementGaugeContainer);
